// src/App.js
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "leaflet/dist/leaflet.css";

import PrivateRoute from './components/PrivateRoute';
import ProtectedLayout from './components/ProtectedLayout';
import LandingPage from './pages/LandingPage';

import Login from './Login';
import Register from './Register';
import Dashboard from './pages/Dashboard';

import AddProduct from './pages/AddProduct';
import CategoryList from './pages/categories/CategoryList';
import ProductList from './pages/products/ProductList';

import DoctorList from './pages/doctors/DoctorList';
import DoctorForm from './pages/doctors/DoctorForm';
import DoctorDetail from './pages/doctors/DoctorDetail';

import OrderList from './pages/orders/OrderList';
import AddOrder from './pages/orders/AddOrder';
import AddOrderItems from './pages/AddOrderItems';
import ModifyOrder from './pages/orders/ModifyOrder';

import CreditNotesList from './pages/creditNotes/CreditNoteList';
import CreditNoteForm from './pages/creditNotes/CreditNoteForm';
import CreditNoteDetail from './pages/creditNotes/CreditNoteDetail';


import BatchList from './pages/batches/BatchList';
import AddBatch from './pages/batches/AddBatch';
import EditBatch from './pages/batches/EditBatch';

import AddPurchase from './pages/purchases/AddPurchase';
import PurchaseList from './pages/purchases/PurchaseList';
import PurchaseDetail from './pages/purchases/PurchaseDetail';
import EditPurchase from './pages/purchases/EditPurchase';

import InvoiceList from './pages/invoices/InvoiceList';
import AddInvoice from './pages/invoices/addInvoice';
import InvoiceDetail from './pages/invoices/InvoiceDetail';
import EditInvoice from './pages/invoices/EditInvoice';


import GSTCategoryList from './pages/gst/GSTCategoryList';
import GSTCategoryForm from './pages/gst/GSTCategoryForm';

import PaymentsList from './pages/payments/PaymentList';
import AddPayments from './pages/payments/AddPayment';

import CustomerPassbook from './components/CustomerPassbook';
import BulkUpload from './components/admin/BulkUpload';

import Expense from './pages/expenses/ExpenseList';
import AddExpense from './pages/expenses/AddExpense';
import ProfitReport from './pages/expenses/ProfitReport';

import CustomerList from './pages/customers/CustomerList';
import AddCustomer from './pages/customers/AddCustomer';
import CustomerDetail from './pages/customers/[id]/CustomerDetail';
import InfoTab from './pages/customers/[id]/tabs/info';
import OrdersTab from './pages/customers/[id]/tabs/orders';
import CreditNotesTab from './pages/customers/[id]/tabs/creditNotes';
import StatementTab from './pages/customers/[id]/tabs/statement';
import InvoiceTab from './pages/customers/[id]/tabs/invoice';
import ProductTab from './pages/customers/[id]/tabs/products';
import VisitTab from './pages/customers/[id]/tabs/visits';
import StatsTab from './pages/customers/[id]/tabs/stats';



import VisitsList from './pages/visits/visitList';
import MarkVisits from './pages/visits/Mark';

import ReportModule from './pages/reports/reportmodule';




import ValidationReports from "./pages/reports/validation"; // 👈 import your validation report page
import UploadsTabs from './components/admin/UploadsTabs';



function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected Routes */}
        <Route path="/dashboard" element={<PrivateRoute><ProtectedLayout><Dashboard /></ProtectedLayout></PrivateRoute>} />

        {/* Products */}
        <Route path="/products" element={<PrivateRoute><ProtectedLayout><ProductList /></ProtectedLayout></PrivateRoute>} />
        <Route path="/products/new" element={<PrivateRoute><ProtectedLayout><AddProduct /></ProtectedLayout></PrivateRoute>} />
        <Route path="/products/edit/:id" element={<PrivateRoute><ProtectedLayout><AddProduct /></ProtectedLayout></PrivateRoute>} />

        {/* Customers */}
        <Route path="/customers" element={<PrivateRoute><ProtectedLayout><CustomerList /></ProtectedLayout></PrivateRoute>} />
        <Route path="/customers/new" element={<PrivateRoute><ProtectedLayout><AddCustomer /></ProtectedLayout></PrivateRoute>} />
        <Route path="/customers/edit/:id" element={<PrivateRoute><ProtectedLayout><AddCustomer /></ProtectedLayout></PrivateRoute>} />

        {/* Customer Detail with nested tabs */}
        <Route path="/customers/:id" element={
          <PrivateRoute>
            <ProtectedLayout>
              <CustomerDetail />
            </ProtectedLayout>
          </PrivateRoute>
        }>
          <Route index element={<InfoTab />} />  {/* default tab */}
          <Route path="info" element={<InfoTab />} />
          <Route path="orders" element={<OrdersTab />} />
          <Route path="statement" element={<StatementTab />} />
          <Route path="credit-notes" element={<CreditNotesTab />} />
          <Route path="invoice" element={<InvoiceTab />} />
          <Route path="products" element={<ProductTab />} />
          <Route path="visits" element={<VisitTab />} />
          <Route path="stats" element={<StatsTab />} />




        </Route>

        {/* Doctors */}
        <Route path="/doctors" element={<PrivateRoute><ProtectedLayout><DoctorList /></ProtectedLayout></PrivateRoute>} />
        <Route path="/doctors/add" element={<PrivateRoute><ProtectedLayout><DoctorForm /></ProtectedLayout></PrivateRoute>} />
        <Route path="/doctors/:id" element={<PrivateRoute><ProtectedLayout><DoctorDetail /></ProtectedLayout></PrivateRoute>} />
        <Route path="/doctors/edit/:id" element={<PrivateRoute><ProtectedLayout><DoctorForm /></ProtectedLayout></PrivateRoute>} />

        {/* Orders */}
        <Route path="/orders" element={<PrivateRoute><ProtectedLayout><OrderList /></ProtectedLayout></PrivateRoute>} />
        <Route path="/orders/new" element={<PrivateRoute><ProtectedLayout><AddOrder /></ProtectedLayout></PrivateRoute>} />
        <Route path="/orders/edit/:id" element={<PrivateRoute><ProtectedLayout><AddOrder /></ProtectedLayout></PrivateRoute>} />
        <Route path="/orders/:orderId/items" element={<PrivateRoute><ProtectedLayout><AddOrderItems /></ProtectedLayout></PrivateRoute>} />
        {/* Modify before invoice */}
        <Route path="/orders/edit/:orderId" element={<PrivateRoute><ProtectedLayout><ModifyOrder /></ProtectedLayout></PrivateRoute>} />

       {/* Credit Note */}
<Route path="/creditNotes" element={<PrivateRoute><ProtectedLayout><CreditNotesList /></ProtectedLayout></PrivateRoute>} />
<Route path="/credit/new" element={<PrivateRoute><ProtectedLayout><CreditNoteForm mode="create" /></ProtectedLayout></PrivateRoute>} />
<Route path="/credit/:id/edit" element={<PrivateRoute><ProtectedLayout><CreditNoteForm mode="edit" /></ProtectedLayout></PrivateRoute>} />
<Route path="/credit/:id" element={<PrivateRoute><ProtectedLayout><CreditNoteDetail /></ProtectedLayout></PrivateRoute>} />


        {/* Modify after invoice (has invoiceId param) */}
        <Route path="/orders/edit/:orderId/:invoiceId" element={<PrivateRoute><ProtectedLayout><ModifyOrder /></ProtectedLayout></PrivateRoute>} />


        {/* Categories */}
        <Route path="/categories" element={<PrivateRoute><ProtectedLayout><CategoryList /></ProtectedLayout></PrivateRoute>} />

        {/* Batches */}
        <Route path="/batches" element={<PrivateRoute><ProtectedLayout><BatchList /></ProtectedLayout></PrivateRoute>} />
        <Route path="/batches/add" element={<PrivateRoute><ProtectedLayout><AddBatch /></ProtectedLayout></PrivateRoute>} />
        <Route path="/batches/edit/:id" element={<PrivateRoute><ProtectedLayout><EditBatch /></ProtectedLayout></PrivateRoute>} />

        {/* Purchases */}
        <Route path="/purchases/add" element={<PrivateRoute><ProtectedLayout><AddPurchase /></ProtectedLayout></PrivateRoute>} />
        <Route path="/purchases" element={<PrivateRoute><ProtectedLayout><PurchaseList /></ProtectedLayout></PrivateRoute>} />
        <Route path="/purchases/:id" element={<PrivateRoute><ProtectedLayout><PurchaseDetail /></ProtectedLayout></PrivateRoute>} />
        <Route path="/purchases/edit/:id" element={<PrivateRoute><ProtectedLayout><EditPurchase /></ProtectedLayout></PrivateRoute>} />

        {/* Invoices */}
        <Route path="/invoices" element={<PrivateRoute><ProtectedLayout><InvoiceList /></ProtectedLayout></PrivateRoute>} />
        
        <Route path="/invoices/add" element={ <PrivateRoute> <ProtectedLayout> <AddInvoice /> </ProtectedLayout> </PrivateRoute> } />
        <Route path="/invoices/:id/edit" element={ <PrivateRoute> <ProtectedLayout><EditInvoice /></ProtectedLayout> </PrivateRoute> } />
        <Route path="/invoices/:id" element={<PrivateRoute><ProtectedLayout><InvoiceDetail /></ProtectedLayout></PrivateRoute>} />
        
        {/* GST */}
        <Route path="/gst-categories" element={<PrivateRoute><ProtectedLayout><GSTCategoryList /></ProtectedLayout></PrivateRoute>} />
        <Route path="/gstcategory/add" element={<PrivateRoute><ProtectedLayout><GSTCategoryForm /></ProtectedLayout></PrivateRoute>} />
        <Route path="/gstcategory/edit/:id" element={<PrivateRoute><ProtectedLayout><GSTCategoryForm /></ProtectedLayout></PrivateRoute>} />

        {/* Payments */}
        <Route path="/payments" element={<PrivateRoute><ProtectedLayout><PaymentsList /></ProtectedLayout></PrivateRoute>} />
        <Route path="/payments/add" element={<PrivateRoute><ProtectedLayout><AddPayments /></ProtectedLayout></PrivateRoute>} />

        {/* Visits */}
        <Route path="/visits" element={<PrivateRoute><ProtectedLayout><VisitsList /></ProtectedLayout></PrivateRoute>} />
        <Route path="/visits/Mark" element={<PrivateRoute><ProtectedLayout><MarkVisits /></ProtectedLayout></PrivateRoute>} />


        {/* Customer Passbook */}
        <Route path="/customers/:id/passbook" element={<PrivateRoute><ProtectedLayout><CustomerPassbook /></ProtectedLayout></PrivateRoute>} />

        {/* Report module */}
        <Route path="/reports/reportmodule" element={<PrivateRoute><ProtectedLayout><ReportModule /></ProtectedLayout></PrivateRoute>} />



        {/* Admin */}
        <Route path="/admin/bulk-upload" element={<PrivateRoute><ProtectedLayout><BulkUpload /></ProtectedLayout></PrivateRoute>} />
        <Route path="/admin/UploadsTabs" element={<PrivateRoute><ProtectedLayout><UploadsTabs /></ProtectedLayout></PrivateRoute>} />

        {/* Expenses */}
        <Route path="/expense" element={<PrivateRoute><ProtectedLayout><Expense /></ProtectedLayout></PrivateRoute>} />
        <Route path="/expense/add" element={<PrivateRoute><ProtectedLayout><AddExpense /></ProtectedLayout></PrivateRoute>} />
        <Route path="/expenses/profit" element={<PrivateRoute><ProtectedLayout><ProfitReport /></ProtectedLayout></PrivateRoute>} />
      
        {/* Reports Module (admin only) */}
        <Route path="/reports/validation" element={<PrivateRoute><ProtectedLayout><ValidationReports /></ProtectedLayout></PrivateRoute>} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
